module.exports = __webpack_public_path__ + "images/340a82b35ad04324d2982cf62df2dfdb.svg";